import { BaseModel } from "model/base.model";

export interface Route extends BaseModel {
  nativePage?: boolean;
};

export const defaultRoute: Readonly<Route> = {};